var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlass3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 49,
    viewBox: "0 0 33 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15034_2040)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8142 2.75977L32.8994 43.9065C32.8994 43.9065 33.1809 48.8215 27.8056 48.8822C21.5264 48.8822 4.95235 48.943 4.95235 48.943C4.95235 48.943 0.0957031 49.1289 0.0957031 42.9449C0.0957031 36.7609 0.184612 2.75977 0.184612 2.75977C0.184612 2.75977 -0.385886 4.84373 14.373 5.312C16.9291 5.37277 31.6695 5.42638 32.8142 2.75977Z",
    fill: "#CFE1EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.195726 10.4665C0.195726 10.4665 1.74793 10.4986 4.08178 10.9991C6.41564 11.4995 15.4103 11.7497 21.1078 10.8418C26.8054 9.93384 32.34 9.40481 32.8253 9.84091C32.8586 11.7783 32.9216 43.4167 32.9216 43.4167C32.9216 43.4167 33.2439 48.9465 27.8056 48.8822C22.2044 48.943 5.4043 48.9751 5.4043 48.9751C5.4043 48.9751 0.258703 49.7258 0.0957031 42.9484C0.129044 36.1711 0.192021 10.4665 0.192021 10.4665H0.195726Z",
    fill: "#7257D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.60549 20.3965H5.60178C4.67292 20.3965 3.91992 21.1231 3.91992 22.0193V37.7652C3.91992 38.6615 4.67292 39.3881 5.60178 39.3881H5.60549C6.53435 39.3881 7.28734 38.6615 7.28734 37.7652V22.0193C7.28734 21.1231 6.53435 20.3965 5.60549 20.3965Z",
    fill: "#AE9BF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5003 5.34134C25.5107 5.34134 32.8151 4.18587 32.8151 2.76052C32.8151 1.33516 25.5107 0.179688 16.5003 0.179688C7.48992 0.179688 0.185547 1.33516 0.185547 2.76052C0.185547 4.18587 7.48992 5.34134 16.5003 5.34134Z",
    fill: "#CFE1EB",
    stroke: "#7257D7",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15034_2040"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 49,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlass3);
export default __webpack_public_path__ + "static/media/glass3.c006ab5c7c16ebb5410cb9f8fa96aa38.svg";
export { ForwardRef as ReactComponent };